import React from 'react'
import WalletPendingForm from './components/PenddingForm'

const index = () => {
  return (
   <>
   <WalletPendingForm/>
   </>
  )
}

export default index